import SaveIcon from "assets/icon/SaveIcon"

export default function SaveButton({ onClick, visible=true }){
    return(
        <button className={`button flex gap-2 ${ visible ? 'block' : 'hidden'} items-center`} onClick={onClick}>
            <SaveIcon className="fill-white w-4" />
            <span className="text-sm">Save</span>
        </button>
    )
}